import * as configuration from '@/configuration/client';
import isInIframe from '@/helpers/isInIframe';

const shouldRedirect = (): boolean => {
  const origin = typeof window !== 'undefined' && window.location?.origin;
  if (origin) {
    if (isInIframe()) {
      return false;
    }
    if (!configuration.GLADE_REDIRECT_TO_HOST || configuration.GLADE_REDIRECT_FROM_HOST.length === 0) {
      return false;
    }
    return configuration.GLADE_REDIRECT_FROM_HOST.includes(origin);
  }
  return false;
};

export default shouldRedirect;
